import { AkrtiServices } from './service.component';

export const akrtiLastestServices:AkrtiServices[] = [
    {
      category: 'Basics - Tailoring',
      services: [ 
        'Saree Blouse',
        'Pattu Blouse',
        'Churidhar Sets',
        'Pavadai Set',
        'Saree Falls',
        'Pico/Zig-Zag',
        'School Uniforms'
      ]
    },
    {
      category: 'Specialization',
      services: [ 
        'Wedding Orders',
        'Pattu Blouse',
        'Designer Sarees',
        'Designer Blouse',
        'Hand Embroidery',
        'Matching Jewellery',
        'Matching Materials'
      ]
    },
    {
      category: 'Value Added Services',
      services: [ 
        'Order From Home',
        'Order Pickup',
        'Home Delivery',
        'Video Consulting',
        'Online Measurement',
        'Alterations',
      ]
    }

  ];